const initialState = {};

const configureDevice = (state = initialState, action) => {
  switch (action.type) {
    case 'updateFCMToken': {
      return {
        ...state,
        fcmToken: action.token,
      };
    }
    case 'updateWhitelist': {
      return {
        ...state,
        whitelist: action.whitelist,
      };
    }
    default: {
      return state;
    }
  }
};

export default configureDevice;



// WEBPACK FOOTER //
// ./src/reducers/device.js